import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@material-ui/core';

/*import { getInitials } from 'helpers';*/
import { Currency } from 'components/DataTypes';
import Percentage from 'components/DataTypes/Percentage';
import Datetime from 'components/DataTypes/Datetime';
import Address from 'components/DataTypes/Address';
import TableToolbar from './TableToolbar';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  date: {
    width: "15rem"
  },
  notAvailable: {
    color: "rgba(0,0,0,0.4)",
    fontStyle: "italic"
  },
  headerElement: {
    whiteSpace: "nowrap"
  },
  numberElement: {
    textAlign: "right"
  }
}));

const InvoiceTable = props => {
  const { className, loadingInvoices, invoices, total, page, rowsPerPage, onChangePage, onFilter, ...rest } = props;

  const classes = useStyles();


  const handlePageChange = (event, page) => {
    onChangePage(page);
  };

  const handleRowsPerPageChange = event => {
    //setRowsPerPage(event.target.value);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <TableToolbar onFilter={onFilter} />
            <Table>
              <colgroup>
                <col />
                <col className={classes.date} />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
                <col />
              </colgroup>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headerElement}>Invoice Number</TableCell>
                  <TableCell className={classes.headerElement}>Created at</TableCell>
                  <TableCell className={`${classes.headerElement} ${classes.numberElement}`}>Gross charge</TableCell>
                  <TableCell className={`${classes.headerElement} ${classes.numberElement}`}>Tax</TableCell>
                  <TableCell className={`${classes.headerElement} ${classes.numberElement}`}>Total</TableCell>
                  <TableCell className={classes.headerElement}>Paid at</TableCell>
                  <TableCell className={classes.headerElement}>Customer name</TableCell>
                  <TableCell className={classes.headerElement}>Address</TableCell>
                  <TableCell className={classes.headerElement}>Country</TableCell>
                  <TableCell className={classes.headerElement}>Customer tax type</TableCell>
                  <TableCell className={classes.headerElement}>Customer tax ID</TableCell>
                  <TableCell className={`${classes.headerElement} ${classes.numberElement}`}>Tax rate</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={loadingInvoices ? "loading" : ""}>
                {invoices.slice(0, rowsPerPage).map(invoice => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={'inv_' + invoice.invoice_number}
                  >
                    <TableCell>
                      {invoice.invoice_uri ? <Link href={invoice.invoice_uri} target="_blank">
                        {invoice.invoice_number}
                      </Link> : invoice.invoice_number}
                    </TableCell>
                    <TableCell>
                      <Datetime value={invoice.created_at} />
                    </TableCell>
                    <TableCell className={classes.numberElement}>
                      <Currency value={invoice.gross_charge} />
                    </TableCell>
                    <TableCell className={classes.numberElement}>
                      <Currency value={invoice.tax_value} />
                    </TableCell>
                    <TableCell className={classes.numberElement}>
                      <Currency value={invoice.total_value} />
                    </TableCell>
                    <TableCell>
                      <Datetime value={invoice.paid_at} />
                    </TableCell>
                    <TableCell>
                      {invoice.account_name || <Typography variant="body1" className={classes.notAvailable}>N/A</Typography>}
                    </TableCell>
                    <TableCell>
                      <Address value={invoice.address_information} />
                    </TableCell>
                    <TableCell>
                      {invoice.country ? invoice.country : <Typography variant="body1" className={classes.notAvailable}>N/A</Typography>}
                    </TableCell>
                    <TableCell>
                      {invoice.tax_type ? invoice.tax_type.toUpperCase() : <Typography variant="body1" className={classes.notAvailable}>N/A</Typography>}
                    </TableCell>
                    <TableCell>
                      {invoice.tax_id || <Typography variant="body1" className={classes.notAvailable}>N/A</Typography>}
                    </TableCell>
                    <TableCell className={classes.numberElement}>
                      <Percentage value={invoice.tax_rate} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={total}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[50]}
          showFirstButton={true}
          showLastButton={true}
        />
      </CardActions>
    </Card>
  );
};

InvoiceTable.propTypes = {
  className: PropTypes.string,
  invoices: PropTypes.array.isRequired
};

export default InvoiceTable;
